//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/ToolDesigner.js";
import "../no/Builder.js";
import "../no/SelectPart.js";
import "../no/SelectObject.js";
let d=[[[1,"ProductSelection",0,"SelectPart",0],[0,"SearchTypes",1,0],[0,"SearchValue",1,0]],[[[],"PerformSearchButton",{},0,0],[[],"PrevSearchResultsButton",{},0,0],[[],"GetCurrentSearchResultsPageNumber",{R_:{pageNumber:''}},0,0],[[],"NextSearchResultsButton",{},0,0],[["productSelection"],"SetProductSelection",{},1,0],[["nDatums","datums"],"InitAssaignedDatumsForProduct",{},0,0]],[]];
SPLM.ToolDesigner.AssociateDatumsUnitDesignsBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.ToolDesigner.AssociateDatumsUnitDesignsBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.ToolDesigner.AssociateDatumsUnitDesignsBuilder.Type = Object.freeze({
    "Id" : "Id", "Name" : "Name"});

export default SPLM;